import React from 'react';
import { IoMdCloseCircle } from 'react-icons/io';
import ErrorMessage from '@components/Error/ErrorMessage'; // Adjust the import path as needed
import Select, { SingleValue, MultiValue } from 'react-select';
import { capitalizeFirstLetter } from '@utils/sharedUtils';
import { useTranslation } from 'react-i18next';

interface Nurse {
    tenant_id: string;
    user_id: string;
    name: string;
    uuid: string;
    nurse_id?: string;
}

interface Device {
    uuid: string;
    device_id: string;
    device_name?: string;
    hospital_id: string;
}

interface ModalPopupProps {
    title: string;
    btn_title: string;
    showModal: boolean;
    onClose: () => void;
    error: string | null;
    handleSubmit: (e: React.FormEvent) => void;
    handleDeviceChange: (option: SingleValue<DeviceOption>) => void;
    handleNurseChange: (options: MultiValue<NurseOption>) => void;
    deviceData: Device[];
    nurseData: Nurse[];
    selectedDeviceOption: SingleValue<DeviceOption>;
    selectedNurseOptions: MultiValue<NurseOption>;
}

interface DeviceOption {
    value: string;
    label: string;
    hospitalId: string;
}

interface NurseOption {
    value: string;
    label: string;
    user_id: string;
    tenant_id: string;
}

const AssignDeviceModal: React.FC<ModalPopupProps> = ({
    title,
    btn_title,
    showModal,
    onClose,
    error,
    handleSubmit,
    handleDeviceChange,
    handleNurseChange,
    deviceData,
    nurseData,
    selectedDeviceOption,
    selectedNurseOptions,
}) => {
    if (!showModal) return null;
    const { t } = useTranslation();

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg relative">
                <div className="text-center text-black text-lg font-semibold">
                    {title}
                </div>
                <button
                    className="absolute top-0 right-0 mt-2 mr-2 text-black"
                    onClick={onClose}
                    aria-label="close"
                >
                    <IoMdCloseCircle className="text-lg" />
                </button>
                <div className="my-4">
                    {error && (
                        <div className="w-11/12 mx-auto">
                            <ErrorMessage message={error} />
                        </div>
                    )}
                    <div className="cart bg-white items-center justify-content-center rounded-2xl w-96 p-4 mx-auto">
                        <form onSubmit={handleSubmit} className="flex flex-col">
                            <div className="mb-4">
                                <label
                                    htmlFor="device_id"
                                    className="block mb-1"
                                >
                                    {t('assigned_device.title_1')}
                                </label>
                                <Select
                                    id="device_id"
                                    name="device_id"
                                    // options={deviceData.map((device) => ({
                                    //     value: device.uuid,
                                    //     label: `${device.device_name} (${device.device_id ? capitalizeFirstLetter(device.device_id) : device.device_id})`,
                                    //     hospitalId: device.hospital_id,
                                    // }))}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    placeholder="Select The Device ID"
                                    value={selectedDeviceOption}
                                    isDisabled
                                />
                                {/* <Select
                                    id="device_id"
                                    name="device_id"
                                    options={deviceData.map((device) => ({
                                        value: device.uuid,
                                        label: `${device.device_name} (${device.device_id ? capitalizeFirstLetter(device.device_id) : device.device_id})`,
                                        hospitalId: device.hospital_id,
                                    }))}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    placeholder="Select The Device ID"
                                    onChange={handleDeviceChange}
                                    value={selectedDeviceOption}
                                    required
                                /> */}
                            </div>
                            <div className="mb-4">
                                <label htmlFor="nurse" className="block mb-1">
                                    {t('assigned_device.title_2')}
                                </label>
                                <div className="border-none text-xs text-secondary font-bold">
                                    {t('assigned_device.title_3')}
                                </div>
                                <Select
                                    id="nurse"
                                    name="nurse"
                                    options={nurseData.map((nurse) => ({
                                        value: nurse.uuid,
                                        label: `${nurse.name} (${nurse.nurse_id ? capitalizeFirstLetter(nurse.nurse_id) : nurse.nurse_id})`,
                                        tenant_id: nurse.tenant_id,
                                        user_id: nurse.user_id,
                                    }))}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    placeholder="Select The Nurse"
                                    onChange={handleNurseChange}
                                    value={selectedNurseOptions}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    required
                                />
                            </div>
                            <button
                                type="submit"
                                className="text-white bg-primary rounded-lg py-2 px-4 my-3"
                            >
                                {btn_title}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssignDeviceModal;
